export default class ScrollingImage extends Phaser.GameObjects.Image {
	private _scrollSpeedX: number;
	private _scrollSpeedY: number;

	constructor(
		scene: Phaser.Scene,
		x: number,
		y: number,
		texture: string,
		frame?: string | number,
		scrollSpeedX?: number,
		scrollSpeedY?: number
	) {
		super(scene, x, y, texture, frame);
		this._scrollSpeedX = scrollSpeedX;
		this._scrollSpeedY = scrollSpeedY;

		if (this.frame.realWidth != this.frame.realHeight) {
			console.warn(
				"Attempting to create a Scrolling Image but size " +
					this.frame.realWidth +
					"x" +
					this.frame.realHeight +
					" is not power of 2."
			);
		}

		this.scene.events.on(Phaser.Scenes.Events.UPDATE, this.sceneUpdate, this);
	}

	sceneUpdate(time: number, delta: number): void {
		this.frame.u0 += (delta / 10000) * this._scrollSpeedX;
		this.frame.u1 += (delta / 10000) * this._scrollSpeedX;
		this.frame.v0 += (delta / 10000) * this._scrollSpeedY;
		this.frame.v1 += (delta / 10000) * this._scrollSpeedY;
	}

	destroy(): void {
		if (this.scene) this.scene.events.off(Phaser.Scenes.Events.UPDATE, this.sceneUpdate, this);
		super.destroy();
	}
}
